import { logger } from "../logger";

/**
 * Returns the UUID of the first world-body root from a parsed result.
 * Falls back to the first key in bodiesMap if worldBodies is empty.
 */
export function getRootBodyUuid(
  parsedWorldBodies: Array<{ uuid: string } | string>,
  parsedBodiesMap: Record<string, unknown>
): string | null {
  if (Array.isArray(parsedWorldBodies) && parsedWorldBodies.length > 0) {
    const rootEntry = parsedWorldBodies[0];
    if (typeof rootEntry === "string") return rootEntry;
    if (rootEntry && typeof rootEntry === "object" && (rootEntry as { uuid: string }).uuid) {
      return (rootEntry as { uuid: string }).uuid;
    }
  }
  const fallback = Object.keys(parsedBodiesMap || {})[0] || null;
  if (fallback) {
    logger.warn("[sceneLoader] No world body root found; falling back to first body UUID");
  }
  return fallback;
}

/** Fetches a URL and wraps the response blob as a named File. */
export async function fetchXmlFile(path: string, filename: string): Promise<File> {
  const res = await fetch(path);
  if (!res.ok) throw new Error(`Failed to fetch ${path} (${res.status})`);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type || "application/xml" });
}
